import { ROLE_LABEL, ROLES, type Role } from '@/types/user'

interface RoleSelectProps {
  id: string
  value: Role
  onChange: (role: Role) => void
}

export function RoleSelect({ id, value, onChange }: RoleSelectProps) {
  return (
    <div>
      <label htmlFor={id} className="block text-sm font-medium text-slate-700">
        Role
      </label>
      <select
        id={id}
        value={value}
        onChange={(event) => onChange(event.target.value as Role)}
        className="mt-1 block w-full rounded-lg border border-slate-300 px-3 py-2 shadow-sm focus:border-primary focus:ring-primary"
      >
        {ROLES.map((role) => (
          <option key={role} value={role}>
            {ROLE_LABEL[role]}
          </option>
        ))}
      </select>
    </div>
  )
}
